import React from "react";
import { MdAddCircle } from "react-icons/md";
import SearchInputBox from "../../../../components/design/searchInputBox/SearchInputBox";
import { StarChartsOrgActionPresentationProps } from "../../types/types";
import { FaClone  } from "react-icons/fa";
import {
  StarChartsOrgActionCol,
  StarChartsOrgActionWrapper,
  StarChartsOrgButton,
  StarChartsOrgTitle,
} from "./starChartOrg.action.presentation.styles";
import SelectField from "../../../../components/design/selectFiled/selectField";
import StarChartOrgCloneContainer from "../../conatiner/starChartOrg.clone.container/StarChartOrgCloneContainer";
const StarChartsOrgActionPresentation: React.FC<StarChartsOrgActionPresentationProps> = ({
  openStarChartsAddHandler,
  term,
  setTerm,
  clonePopup,
  onClonePopup
}) => {

  return (
    <>
        <StarChartsOrgActionWrapper style={{justifyContent:"space-between", paddingTop:35}}>
      <StarChartsOrgActionCol style={{ width: '24%',display:"flex", flexDirection:"row" }}>
        <SearchInputBox
          name="starCharts"
          type="Search StarChart"
          placeholder="Search StarCharts"
          value={term}
          onChange={(e) => { setTerm!(e.target.value) }}
        />

            <StarChartsOrgActionCol style={{marginLeft:10}}>
              <StarChartsOrgTitle>Status</StarChartsOrgTitle>

              <SelectField defaultValue={""} onChange={() => {}}>
                <option value="Standard">All</option>
                <option value="Academic">Active</option>
                <option value="Academic">Deactive</option>
              </SelectField>
            </StarChartsOrgActionCol>
      </StarChartsOrgActionCol>
      <StarChartsOrgActionCol style={{width:'auto', padding:0 ,display:"flex", flexDirection:"row"}}>
        <StarChartsOrgButton
          style={{
            padding:"6px 4px 6px 20px",
            fontSize: 16
          }}
          onClick={openStarChartsAddHandler}
          spaceLeft={''}
        >
          <MdAddCircle size={32} />
          <span style={{ paddingRight: 18, paddingLeft:5 }}>Create Star Chart</span>
     
        </StarChartsOrgButton>
        <StarChartsOrgButton
          style={{
            padding:"6px 4px 6px 20px",
            fontSize: 16,
            marginLeft:10
          }}
          onClick={onClonePopup}
          spaceLeft={''}
        >
          <FaClone  size={20} />
          <span style={{ paddingRight: 18, paddingLeft:5 }}>Clone Star Chart</span>
     
        </StarChartsOrgButton>
      </StarChartsOrgActionCol>
    </StarChartsOrgActionWrapper>

    <StarChartOrgCloneContainer starChartClone={clonePopup} clonePopup={onClonePopup} />
 
    </>
 )
}

export default StarChartsOrgActionPresentation
